import * as tslib_1 from "tslib";
import { Validators } from '@angular/forms';
import { format, parse } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
var DeadlinesContractsMapper = /** @class */ (function () {
    function DeadlinesContractsMapper() {
    }
    DeadlinesContractsMapper.toWeekDay = function (digitOfDay) {
        return this.daysOfWeek[digitOfDay];
    };
    DeadlinesContractsMapper.toTime = function (_a) {
        var valueInMinutes = _a.valueInMinutes, time = _a.time, unity = _a.unity;
        var sanitizedTime = Number(time || valueInMinutes);
        var isConversionFromMinutes = !!valueInMinutes;
        if (!sanitizedTime || isNaN(sanitizedTime)) {
            return 0;
        }
        if (isConversionFromMinutes && unity === 'hours') {
            return sanitizedTime / 60;
        }
        if (!isConversionFromMinutes && unity === 'hours') {
            return sanitizedTime * 60;
        }
        if (isConversionFromMinutes && unity === 'days') {
            return sanitizedTime / 1440;
        }
        if (!isConversionFromMinutes && unity === 'days') {
            return sanitizedTime * 1440;
        }
        return sanitizedTime;
    };
    DeadlinesContractsMapper.toTimeWithTimezone = function (value) {
        if (!value) {
            return null;
        }
        var utcTime = new Date("1970-01-01T" + value + "Z");
        return formatInTimeZone(utcTime, this.timezone, 'HH:mm');
    };
    DeadlinesContractsMapper.toCustomIntervalInput = function (intervals) {
        var e_1, _a;
        if (!intervals || !intervals.length) {
            return null;
        }
        var customInterval = {};
        try {
            for (var _b = tslib_1.__values(intervals.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = tslib_1.__read(_c.value, 2), index = _d[0], interval = _d[1];
                if (interval.consider) {
                    var day = this.toWeekDay(index);
                    customInterval[day] = {
                        start: format(parse(interval.start, 'HH:mm:ss', new Date()), 'HH:mm'),
                        end: format(parse(interval.end, 'HH:mm:ss', new Date()), 'HH:mm')
                    };
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return customInterval;
    };
    DeadlinesContractsMapper.toCustomIntervalForm = function (customInterval, formBuilder) {
        var controls = [];
        for (var digitOfDay = 0; digitOfDay < 7; digitOfDay++) {
            var weekDay = DeadlinesContractsMapper.toWeekDay(digitOfDay);
            var dayInterval = customInterval && customInterval[weekDay];
            var startValue = dayInterval ? this.toTimeWithTimezone(dayInterval.start) : null;
            var endValue = dayInterval ? this.toTimeWithTimezone(dayInterval.end) : null;
            var dayGroup = formBuilder.group({
                consider: [Boolean(dayInterval), [Validators.required]],
                start: [{ disabled: Boolean(dayInterval), value: startValue }],
                end: [{ disabled: Boolean(dayInterval), value: endValue }]
            });
            controls.push(dayGroup);
        }
        return formBuilder.array(controls);
    };
    DeadlinesContractsMapper.toDeadlineContractInput = function (formGroupValue) {
        return {
            name: formGroupValue.name,
            description: formGroupValue.description,
            considerHoliday: formGroupValue.considerHoliday,
            customIntervalTimezone: formGroupValue.customInterval && formGroupValue.customInterval.length && this.timezone,
            customInterval: this.toCustomIntervalInput(formGroupValue.customInterval),
            deadlineViolationReasonIds: (formGroupValue.violationReasons || []).map(function (_a) {
                var id = _a.id;
                return id;
            }),
            responseRisk: {
                valueInMinutes: this.toTime(formGroupValue.responseRisk),
                unity: formGroupValue.responseRisk.unity
            },
            responseDeadline: {
                valueInMinutes: this.toTime(formGroupValue.responseDeadline),
                unity: formGroupValue.responseDeadline.unity
            },
            solutionRisk: {
                valueInMinutes: this.toTime(formGroupValue.solutionRisk),
                unity: formGroupValue.solutionRisk.unity
            },
            solutionDeadline: {
                valueInMinutes: this.toTime(formGroupValue.solutionDeadline),
                unity: formGroupValue.solutionDeadline.unity
            }
        };
    };
    DeadlinesContractsMapper.toDeadlineContractForm = function (deadlineContract) {
        return {
            name: deadlineContract.name,
            description: deadlineContract.description,
            considerHoliday: deadlineContract.considerHoliday,
            hasCustomInterval: deadlineContract.hasCustomInterval,
            violationReasons: deadlineContract.deadlineViolationReasons && deadlineContract.deadlineViolationReasons.length
                ? deadlineContract.deadlineViolationReasons
                : null,
            responseRisk: {
                time: this.toTime(deadlineContract.responseRisk),
                unity: deadlineContract.responseRisk.unity,
            },
            solutionRisk: {
                time: this.toTime(deadlineContract.solutionRisk),
                unity: deadlineContract.solutionRisk.unity,
            },
            responseDeadline: {
                time: this.toTime(deadlineContract.responseDeadline),
                unity: deadlineContract.responseDeadline.unity,
            },
            solutionDeadline: {
                time: this.toTime(deadlineContract.solutionDeadline),
                unity: deadlineContract.solutionDeadline.unity,
            }
        };
    };
    DeadlinesContractsMapper.daysOfWeek = {
        0: 'sunday',
        1: 'monday',
        2: 'tuesday',
        3: 'wednesday',
        4: 'thursday',
        5: 'friday',
        6: 'saturday',
    };
    DeadlinesContractsMapper.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return DeadlinesContractsMapper;
}());
export { DeadlinesContractsMapper };
